import React from 'react';
import Slider from 'react-slick';
import './Groom.css';


const GroomOffer = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 100,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    autoplaySpeed: 1500,
  };

  const offers = [
    {
      title: 'Smile Makeover for Brides & Grooms',
      details: [
        'Consultation',
        'Teeth Whitening',
        'Ultrasonic Cleaning',
        'Smile Makeover / Veneers',
        'Dental Polishing',
      ],
      price: '₹6,999',
      oldPrice: '₹10,500',
    },
    {
      title: 'Free Consultation Wednesdays',
      details: ['Book any Wednesday', 'No cost for basic dental exam'],
    },
    {
      title: '20% Off on Teeth Whitening',
      details: ['Valid all month', 'Safe, painless whitening'],
    },
    {
      title: '₹500 Off on First Visit',
      details: ['New patients only', 'Includes cleaning + consultation'],
    },
    {
      title: 'No Cost EMI on Smile Makeovers',
      details: ['Flexible payment plans', '0% interest EMI available'],
    },
  ];

  return (
    <section className="groom-offer">
      <div className="offer-slider-wrapper">
        <h2 className="offer-section-title">🦷 Current Deals at Dr. Srishti’s Clinic</h2>
  <Slider {...settings}>
    {offers.map((offer, index) => (
      <div key={index}>
        <div className="offer-slide">
          <h2>🎁 {offer.title}</h2>
          <ul>
            {offer.details.map((item, idx) => (
              <li key={idx}>✔ {item}</li>
            ))}
          </ul>
          {offer.price && (
            <p className="offer-price">
              Starting at <strong>{offer.price}</strong>{' '}
              {offer.oldPrice && <span className="old-price">{offer.oldPrice}</span>}
            </p>
          )}
          <button
            onClick={() =>
              window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' })
            }
          >
            Book Now
          </button>
        </div>
      </div>
    ))}
  </Slider>
      </div>
    </section>
  );
}
export default GroomOffer;